/*======================================================================================================================
  * Bluebell: src/app/state/postpro-settings/postpro-settings.actions.ts
  * Last Edited: 23/05/2025
  * Copyright 2025 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { createAction } from '@ngrx/store';
import { PostproSettings } from '@state/postpro-settings/postpro-settings.interfaces';

function name(action: string) {
  return `[Postpro Settings] ${action}`;
}

/*
  Load Postpro Settings
*/

export const loadPostproSettings = createAction(name('Load'));
export const loadPostproSettingsSuccess = createAction(
  name('Load Success'),
  (loadedSettings: PostproSettings) => ({ loadedSettings })
);
export const loadPostproSettingsFailure = createAction(name('Load Failure'));

/*
  Update Postpro Settings
*/

export const savePostproSettings = createAction(
  name('Save'),
  (settings: PostproSettings) => ({ settings })
);
export const savePostproSettingsSuccess = createAction(
  name('Save Success'),
  (loadedSettings: PostproSettings) => ({ loadedSettings })
);
export const savePostproSettingsFailure = createAction(name('Save Failure'));
